import { Box, Divider, Heading, Stack, Text } from "@sembark-travel/ui-base"
import { Helmet } from "react-helmet-async"
import { NewDefaultCancellationPolicy } from "../../../CancellationPolicy"
import { useNavigate } from "../../../router-utils"

export default function OnboardingCancellationPolicyPage() {
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>Cancellation Policy | Onboarding</title>
			</Helmet>
			<Box
				maxWidth="4xl"
				marginX="auto"
				padding="8"
				borderWidth="1"
				rounded="md"
				bgColor="default"
				marginBottom="16"
			>
				<Box
					borderBottomWidth="1"
					display="inlineBlock"
					fontWeight="semibold"
					marginBottom="8"
					color="primary"
					fontSize="lg"
				>
					Onboarding &gt; Policies
				</Box>
				<Stack gap="2">
					<Heading as="h3">Set Default Cancellation Policy</Heading>
					<Text>
						Set cancellation charges based on how early a booking is cancelled.
						This policy applies to all bookings by default.
					</Text>
				</Stack>
				<Divider />
				<NewDefaultCancellationPolicy
					onSuccess={() => navigate("/onboarding/payment-policy")}
				/>
			</Box>
		</>
	)
}
